import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {Axes} from "../../models/axes";

@Injectable({
  providedIn: 'root'
})
export class AxesService {

  constructor(private http: HttpClient) { }

  list(): Observable<Array<Axes>> {
    return this.http.get('/api/qualif_pme_axe/') as Observable<Array<Axes>>;
  }

  create(data: Axes): Observable<Axes> {
    return this.http.post('/api/qualif_pme_axe/', data) as Observable<Axes>;
  }

  update(slug: string, data: Axes): Observable<Axes> {
    return this.http.put(`/api/qualif_pme_axe/${slug}/`, data) as Observable<Axes>;
  }

  delete(slug: string): Observable<Axes> {
    return this.http.delete(`/api/qualif_pme_axe/${slug}/`) as Observable<Axes>;
  }

  retrieve(slug: string): Observable<Axes> {
    return this.http.get(`/api/qualif_pme_axe/${slug}/`) as Observable<Axes>;
  }
}
